import isFunction from 'lodash/isFunction'
import { SkDrawer } from 'sk-ui'
import { extend } from 'sk-ui/lib/utils/util.js'
import { backfill } from 'sk-web-framework/utils'

import SkyDialogFormAdapter from '@/components/dialogFormAdapter'
const adapter = {
  actions: {
    OpenDialogForm({ commit }, { metaData, props, dialogProps }) {
      const cbOk = dialogProps && isFunction(dialogProps.cbOk) ? dialogProps.cbOk : () => {}
      this.$root.$dialog({
        template: h => {
          const _metaData = extend(true, {}, metaData)
          backfill(_metaData, { ...props })
          return <sky-dialog-form-adapter metaData={_metaData} cbOk={cbOk}></sky-dialog-form-adapter>
        },
        components: { SkyDialogFormAdapter },
        props: dialogProps
      })
    },
    OpenDrawerDetailRelation({ commit }, { metaData, props, drawerProps }) {
      const hx = this.$root.$createElement
      // const cbCloseDrawer = drawerProps && isFunction(drawerProps.cbCloseDrawer) ? drawerProps.cbCloseDrawer : () => {}
      var title = drawerProps && drawerProps.title ? drawerProps.title : '详情信息'
      if (this.drawer?.title) {
        this.drawer[title].close()
        this.drawer[title] = null
        return
      }

      const _metaData = extend(true, {}, metaData)
      backfill(_metaData, { ...props })

      const self = this
      if (!this.drawer) {
        this.drawer = []
        this.drawerIndex = {}
      }
      for (const page of this.drawer) {
        page.showPage = false
      }
      var customclass = drawerProps && drawerProps.class ? drawerProps.class : ''

      var pageClass = 'wsp-custom-drawer-page ' + customclass

      // wsp-case-relation-drawer-45

      var drawerPage = SkDrawer({
        title: title,
        customClass: pageClass,
        showMore: false,
        content: hx('sky-drawer-relation-adapter', {
          props: {
            metaData: _metaData,
            drawerProps: drawerProps
          }
        }),
        onClose() {},
        parent: this.$root
      })
      drawerPage.close = function() {
        var index = self.drawerIndex[title]
        if (self.drawer[index].showPage && !self.drawer[index].closed) {
          self.drawer[index].closed = true
          if (typeof self.drawer[index].onClose === 'function') {
            self.drawer[index].onClose()
          }
          self.drawer.pop()
          self.drawer[index - 1].showPage = true
        }
      }
      drawerPage.showPage = true
      this.drawer.push(drawerPage)
      this.drawerIndex[title] = this.drawer.length - 1
    }
  }
}
export default adapter
